(function () {
  var boundSlideshow = null;
  var recenterQueued = false;

  function updateSizeGuideLabels(member) {
    var labels = document.querySelectorAll('[data-halloween-size-guide]');
    if (!labels.length) return;
    var key = member === 'human' ? 'human' : 'dog';
    labels.forEach(function (link) {
      var text = link.getAttribute('data-label-' + key);
      var textEl = link.querySelector('[data-halloween-size-guide-text]');
      if (text && textEl) textEl.textContent = text;
    });
  }

  function getHalloweenRoot() {
    return document.querySelector('.ProductSet--halloween-multi[data-product-set-root]')
      || document.querySelector('.ProductSet--halloween-multi');
  }

  function stickyOffset() {
    var header = document.querySelector('#section-header, .Header');
    return header ? Math.round(header.getBoundingClientRect().height) : 0;
  }

  function findHalloweenReviews() {
    return document.querySelector('[data-product-set-loox-reviews]')
      || document.querySelector('#looxReviews')
      || document.querySelector('[id*="looxReviews"]');
  }

  function scrollToHalloweenReviews() {
    var reviews = findHalloweenReviews();
    if (!reviews) return false;
    var top = reviews.getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 12;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  function onHalloweenRatingClick(event) {
    var target = event.target;
    if (target && target.nodeType !== 1) target = target.parentElement;
    if (!target || typeof target.closest !== 'function') return;
    if (!target.closest('.ProductSet--halloween-multi')) return;

    var ratingWrap = target.closest('[data-scroll-to-reviews], .HalloweenPdp__Rating, .HalloweenPdp__Rating .loox-rating');
    if (!ratingWrap) return;

    if (scrollToHalloweenReviews()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  function getHalloweenFlickity() {
    var root = getHalloweenRoot();
    if (!root || !window.Flickity) return null;
    var slideshow = root.querySelector('[data-product-set-active-content] .Product__Slideshow')
      || root.querySelector('.Product__Slideshow');
    if (!slideshow) return null;
    return Flickity.data(slideshow);
  }

  function recenterHalloweenSlideshow(forceSelect) {
    var flkty = getHalloweenFlickity();
    if (!flkty || !flkty.cells || !flkty.cells.length) return;

    flkty.cells.forEach(function (cell) {
      if (!cell.element) return;
      cell.element.style.removeProperty('display');
      cell.element.classList.remove('Product__SlideItem--hidden');
    });

    try {
      flkty.resize();
      if (typeof flkty.reposition === 'function') flkty.reposition();
      if (forceSelect && typeof flkty.select === 'function') {
        var idx = flkty.selectedIndex || 0;
        if (idx < 0) idx = 0;
        if (idx > flkty.cells.length - 1) idx = flkty.cells.length - 1;
        flkty.select(idx, false, true);
      }
    } catch (e) {}
  }

  function queueRecenter(forceSelect) {
    if (recenterQueued) return;
    recenterQueued = true;
    window.requestAnimationFrame(function () {
      recenterQueued = false;
      recenterHalloweenSlideshow(!!forceSelect);
    });
  }

  function bindHalloweenSlideshow() {
    var flkty = getHalloweenFlickity();
    if (!flkty || flkty === boundSlideshow) return;

    boundSlideshow = flkty;
    flkty.on('settle', function () {
      if (typeof flkty.reposition === 'function') {
        try { flkty.reposition(); } catch (e) {}
      }
    });
    flkty.on('dragEnd', function () {
      queueRecenter(true);
    });
    queueRecenter(true);
  }

  function onHalloweenNavClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('.ProductSet--halloween-multi')) return;
    if (!target.closest('.Product__SlideshowNavArrow, .Product__SlideshowMobileNav .dot')) return;
    window.setTimeout(function () {
      queueRecenter(true);
    }, 350);
  }

  function initHalloweenSlideshow() {
    if (!getHalloweenRoot()) return;
    bindHalloweenSlideshow();
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      bindHalloweenSlideshow();
      if (boundSlideshow || attempts >= 20) window.clearInterval(timer);
    }, 150);
  }

  document.addEventListener('product-set:content-replaced', function (event) {
    var member = event && event.detail && event.detail.member;
    if (member) updateSizeGuideLabels(member);
    boundSlideshow = null;
    window.setTimeout(function () {
      initHalloweenSlideshow();
    }, 50);
  });

  document.addEventListener('product-set:hero-dismissed', function () {
    queueRecenter(true);
  });

  document.addEventListener('click', onHalloweenNavClick);
  document.addEventListener('click', onHalloweenRatingClick, true);

  window.addEventListener('resize', function () {
    if (!getHalloweenRoot()) return;
    queueRecenter(true);
  });

  window.addEventListener('orientationchange', function () {
    if (!getHalloweenRoot()) return;
    window.setTimeout(function () {
      queueRecenter(true);
    }, 120);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHalloweenSlideshow);
  } else {
    initHalloweenSlideshow();
  }
})();
